import Vue from 'vue';

import InputError from '@/components/UI/Inputs/InputError.vue';
import Button from '@/components/UI/Button.vue';
import Calendar from '@/components/UI/PrimevueModified/Calendar.vue';
import Accordion from '@/components/UI/PrimevueModified/Accordion.vue';
import AccordionTab from '@/components/UI/PrimevueModified/AccordionTab.vue';
import Checkbox from '@/components/UI/PrimevueModified/Checkbox.vue';
import RadioButton from '@/components/UI/PrimevueModified/RadioButton.vue';
import SeparatorLine from '@/components/UI/SeparatorLine.vue';
import StaticImage from '@/components/UI/StaticImage.vue';
import Breadcrumb from '@/components/Generic/Breadcrumb.vue';
import MainSkipToContentLink from '@/components/Generic/MainSkipToContentLink.vue';
import FocusMagnetLink from '@/components/Generic/FocusMagnetLink.vue';
import LightboxGalleryCarousel from '@/components/Carousels/LightboxGalleryCarousel/LightboxGalleryCarousel.vue';
import T from '@/components/UI/T/T.vue';

Vue.component('InputError', InputError);
Vue.component('Button', Button);
Vue.component('SeparatorLine', SeparatorLine);
Vue.component('StaticImage', StaticImage);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('Checkbox', Checkbox);
Vue.component('RadioButton', RadioButton);
Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('Calendar', Calendar);
Vue.component('MainSkipToContentLink', MainSkipToContentLink);
Vue.component('FocusMagnetLink', FocusMagnetLink);
Vue.component('LightboxGalleryCarousel', LightboxGalleryCarousel);

Vue.component('T', T);
